<!-- 同步店铺订单 -->
<template>
<el-dialog :title="msg('同步店铺订单')" :visible.sync="visible" :fullscreen="isMinScreen" >
   <div>
        <div style="margin-bottom: 15px; ">
           <el-radio-group v-model="days" size="medium" @change=change()>
                <el-radio-button :label="3" >{{msg('近3天')}}</el-radio-button>
                <el-radio-button :label="7" >{{msg('近7天')}}</el-radio-button>
                <el-radio-button :label="14" >{{msg('近14天')}}</el-radio-button>
            </el-radio-group>
        </div>
        <div style="margin-bottom: 15px; ">
           <el-date-picker size="medium"
                v-model="startDate"
                type="date"
                placeholder="选择开始日期">
            </el-date-picker>
        </div>
        <div>
            <p style="text-indent:2em">温馨提醒：如同步店铺订单遇到问题，可打开网址https://www.kdocs.cn/l/caPV4roCNe31参考相关说明来处理；</p>
        </div>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="enter"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
            <el-button  size="mini" v-on:click="visible = false">{{msg('取消')}}</el-button>
        </div>
    </div>
</el-dialog>
</template>
<script>
export default {
    name: "StockSyncOrder",
    data(){
        return{
            days: 0,
            startDate: null,
            visible: false
        }
    },
    props: {
        isMinScreen: Boolean
    },
    methods: {
        showDialog(){
            this.visible = true;
            this.startDate = null;
        },
        change(){
            let dayL = this.days * 24 * 3600 * 1000;
            dayL = new Date().getTime() - dayL;
            this.startDate = new Date(dayL);
        },
        enter(){
            this.$axios.post(this.$kit.api.shop.syncOrder+"?st="+this.startDate.getTime())
                .then((result) => {
                    if(result.status){
                        this.$message(result.msg || this.msg('同步失败'));
                        this.visible = false;
                    }else{
                        this.$message(this.msg('同步失败'));
                    }
                });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>